import { Navigate, useParams } from 'react-router-dom';
import RootLanding from '../../components/layouts/RootLanding';
import { Wadah } from '../../components/fragments/landing/publik/Elemen';
import Ikon from '../../components/fragments/landing/publik/Ikon';
import {
    HeroMisi,
    KartuKonten,
    KepalaSeksi,
    SeksiBeritaTerbaru,
    SeksiFaq,
    SeksiGaleri,
} from '../../components/fragments/landing/publik/Seksi';
import { KONVENSI, TOPIK, kartuDokumen } from '../../components/fragments/landing/publik/topikPublik';

/*
 * Halaman topik di bawah menu Informasi (frame Figma "Direktorat Pengelolaan
 * B3 — Informasi"): Merkuri, PCBs, Pelayanan Publik, Konvensi Internasional,
 * serta halaman per konvensi.
 */

const ikonKonvensi = ['labu', 'tunas', 'buku'];

function SeksiDokumen({ topik }) {
    const ke = `/arsip?kategori=${encodeURIComponent(topik.kategori)}`;
    return (
        <div className="flex flex-col gap-8">
            <KepalaSeksi label="Dokumen & Peraturan" judul="Dokumen & Peraturan" tautan="Jelajahi dokumen & peraturan" ke={ke} />
            <div className="grid gap-10 md:grid-cols-3 md:gap-8">
                {kartuDokumen(topik).map((k) => (
                    <KartuKonten key={k.label} {...k} ke={ke} />
                ))}
            </div>
        </div>
    );
}

/* Tautan ke halaman lama yang tidak punya menu lagi (khusus Merkuri). */
function SeksiLayananTerkait({ daftar }) {
    return (
        <div className="flex flex-col gap-8">
            <KepalaSeksi label="Layanan terkait" judul="Data & layanan merkuri" />
            <div className="grid gap-10 md:grid-cols-3 md:gap-8">
                {daftar.map((l, i) => (
                    <KartuKonten
                        key={l.judul}
                        label={l.label}
                        judul={l.judul}
                        uraian={l.uraian}
                        tautan="Buka layanan"
                        ke={l.ke}
                        href={l.href}
                        ikon={ikonKonvensi[i]}
                    />
                ))}
            </div>
        </div>
    );
}

function HalamanTopik({ topik }) {
    return (
        <RootLanding>
            <HeroMisi judul={topik.judul} pengantar={topik.pengantar} gambar={topik.gambar} />
            <section className="bg-white">
                <Wadah className="flex flex-col gap-16 py-[72px]">
                    <SeksiBeritaTerbaru kategori={topik.kategori} ke={`/berita?kategori=${encodeURIComponent(topik.kategori)}`} />
                    <SeksiDokumen topik={topik} />
                    {topik.layananTerkait && <SeksiLayananTerkait daftar={topik.layananTerkait} />}
                </Wadah>
            </section>
            <SeksiGaleri kategori={topik.kategori} />
            <SeksiFaq sebutan={topik.sebutan} kata={topik.kataFaq} />
        </RootLanding>
    );
}

function HalamanKonvensiInternasional({ topik }) {
    return (
        <RootLanding>
            <HeroMisi judul={topik.judul} pengantar={topik.pengantar} gambar={topik.gambar} />
            <section className="bg-white">
                <Wadah className="flex flex-col gap-8 py-[72px]">
                    <KepalaSeksi label="Berita & Artikel" judul="Konvensi Internasional B3" />
                    <div className="grid gap-10 md:grid-cols-3 md:gap-8">
                        {KONVENSI.map((k, i) => (
                            <KartuKonten
                                key={k.slug}
                                judul={k.judul}
                                tautan="Jelajahi topik"
                                ke={`/informasi/${topik.slug}/${k.slug}`}
                                ikon={ikonKonvensi[i]}
                            />
                        ))}
                    </div>
                </Wadah>
            </section>
        </RootLanding>
    );
}

/* Bagian isi halaman konvensi; selama teks dari customer belum ada, tampil keterangan. */
function BagianKonvensi({ label, judul, paragraf, ikon }) {
    return (
        <div className="flex flex-col gap-8">
            <KepalaSeksi label={label} judul={judul} />
            {paragraf.length ? (
                <div className="flex max-w-[900px] flex-col gap-4 font-body text-base leading-[1.7] text-pb-teks">
                    {paragraf.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>
            ) : (
                <div className="flex items-center gap-6 rounded-md bg-pb-kabut p-6">
                    <Ikon nama={ikon} className="hidden size-11 shrink-0 text-pb-aksen sm:block" />
                    <p className="font-body text-[15px] text-pb-teks">Informasi pada bagian ini sedang disiapkan dan akan segera tersedia.</p>
                </div>
            )}
        </div>
    );
}

function HalamanKonvensi({ topik, konvensi }) {
    return (
        <RootLanding>
            <HeroMisi judul={konvensi.judul} gambar={topik.gambar} />
            <section className="bg-white">
                <Wadah className="flex flex-col gap-16 py-[72px]">
                    <BagianKonvensi label="Sejarah" judul="Sejarah" paragraf={konvensi.isi.sejarah} ikon="tunas" />
                    <BagianKonvensi label="Ketentuan" judul="Ketentuan Konvensi" paragraf={konvensi.isi.ketentuan} ikon="buku" />
                </Wadah>
            </section>
            <section className="border-t border-pb-garis bg-pb-kertas">
                <Wadah className="py-[72px]">
                    <BagianKonvensi
                        label="Peran Indonesia"
                        judul={`Peran Indonesia dalam ${konvensi.judul}`}
                        paragraf={konvensi.isi.peran}
                        ikon="buku"
                    />
                </Wadah>
            </section>
            <SeksiGaleri kategori={topik.kategori} />
        </RootLanding>
    );
}

export default function InformasiTopikPage() {
    const { topik: slugTopik, konvensi: slugKonvensi } = useParams();
    const topik = TOPIK.find((t) => t.slug === slugTopik);
    if (!topik) return <Navigate to="/" replace />;

    if (topik.slug === 'konvensi-internasional') {
        if (slugKonvensi) {
            const konvensi = KONVENSI.find((k) => k.slug === slugKonvensi);
            if (!konvensi) return <Navigate to={`/informasi/${topik.slug}`} replace />;
            return <HalamanKonvensi topik={topik} konvensi={konvensi} />;
        }
        return <HalamanKonvensiInternasional topik={topik} />;
    }
    if (slugKonvensi) return <Navigate to={`/informasi/${topik.slug}`} replace />;
    return <HalamanTopik topik={topik} />;
}
